import React from 'react'
import { withRouter} from 'react-router-dom'



class ExplorerDashboardPage extends React.Component{ 
 


	render(){

 
		return( 

			<div className='page page--sidePanelLayout' >
				<div className='page-leftPanel'/>
				<div className={'repo-content'} >			
					<div>
						Explorer Dashboard
						<br/>
						<br/>
						<button onClick={()=>{this.props.history.push('/explorer/crossfilter')}}>Crossfilter</button>
					</div>

				</div>
			</div>
		)
	}
}


export default withRouter(ExplorerDashboardPage)


